import React from 'react';
import * as Popover from '@radix-ui/react-popover';
import { PerfectScrollbar } from 'components/shared/ReactPerfectScrollbar';
import { DeviceChartMarkerPopupItem } from './DeviceChartMarkerPopupItem';
import styles from './DeviceChartMarkerPopup.module.css';

function DeviceChartMarkerPopup({ open, virtualRef, markers, onEdit, onDelete, ...rest }) {
  return (
    <Popover.Root open={open}>
      <Popover.Anchor virtualRef={virtualRef} />
      <Popover.Portal>
        <Popover.Content className={styles.content} side="top" align="center" forceMount={true} {...rest}>
          <PerfectScrollbar>
            <div className={styles.list}>
              {markers.map((marker, index) => (
                <DeviceChartMarkerPopupItem
                  key={marker.id}
                  index={index}
                  marker={marker}
                  onEdit={onEdit}
                  onDelete={onDelete}
                />
              ))}
            </div>
          </PerfectScrollbar>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}

export { DeviceChartMarkerPopup };
